module.exports = __webpack_public_path__ + "static/media/cellfind_logo.8cf6086f.png";